import { NavLink, Outlet } from 'react-router-dom'
import { User, Shield, Crown } from 'lucide-react'

const sidebarItems = [
  {
    label: 'Бүртгэл',
    fullLabel: 'Бүртгэлийн тохиргоо',
    icon: User,
    to: '/settings',
    end: true,
  },
  {
    label: 'Аюулгүй байдал',
    fullLabel: 'Нууцлал ба Аюулгүй байдал',
    icon: Shield,
    to: '/settings/security',
    end: false,
  },
  {
    label: 'Premium',
    fullLabel: 'Premium эрх',
    icon: Crown,
    to: '/settings/premium',
    end: false,
  },
]

export default function Settings() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-[1024px] mx-auto px-4 flex flex-col md:flex-row gap-3">
        {/* Mobile top tabs */}
        <aside className="w-full md:w-[200px] shrink-0 pt-4 md:pt-[60px]">
          {/* Mobile: horizontal pill tabs */}
          <nav className="flex md:hidden gap-1 bg-gray-100 rounded-xl p-1">
            {sidebarItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex-1 flex items-center justify-center gap-1.5 px-3 py-2.5 text-xs font-semibold transition rounded-lg whitespace-nowrap ${
                    isActive
                      ? 'bg-white shadow-sm text-primary-500'
                      : 'text-gray-500'
                  }`
                }
              >
                <item.icon className="size-4" />
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* Desktop: vertical sidebar */}
          <nav className="hidden md:flex flex-col gap-3">
            {sidebarItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-4 py-3 text-sm font-semibold transition rounded-xl whitespace-nowrap ${
                    isActive
                      ? 'bg-white border border-gray-200 border-l-4 border-l-primary-500 text-primary-500'
                      : 'text-gray-600 hover:bg-gray-100'
                  }`
                }
              >
                <item.icon className="size-4" />
                {item.label}
              </NavLink>
            ))}
          </nav>
        </aside>

        {/* Right content */}
        <main className="flex-1 pt-4 md:pt-[60px] pb-20">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
